module.exports = __webpack_public_path__ + "static/media/robot.36560557.png";